import ProjectPropertyLookup from "./project-property-lookup";
import ProjectSession from "../project-session"

export default class TasksCustomFieldsLookup extends ProjectPropertyLookup {

    // constructor is required for convenient navigation in IDE
    constructor(projectId: ID) {
        super(projectId)
    }

    get() {
        let ownCustomFieldsIds: ID[] = []
        let inheritedCustomFieldsIds: ID[] = []

        // 1. check if project has property and retrieve custom fields
        if (!!this.project.customFields) {
            ownCustomFieldsIds = this.getProjectTasksCustomFields(this.project);
        }

        // 2. get all inherited custom fields
        _.map(this.findAllParents(), project=>{
            inheritedCustomFieldsIds = inheritedCustomFieldsIds.concat(this.getProjectTasksCustomFields(project));
        });

        // clear all duplicates
        ownCustomFieldsIds             = _.uniq(ownCustomFieldsIds);
        inheritedCustomFieldsIds    = _.uniq(inheritedCustomFieldsIds);

        // remove from ownCustomFieldsIds ids that already present in inheritedCustomFieldsIds
        ownCustomFieldsIds = _.filter(ownCustomFieldsIds, id=>!inheritedCustomFieldsIds.includes(id))

        return {
            ownCustomFieldsIds,
            inheritedCustomFieldsIds
        };
    }

    // return CF ids ?
    getForChildren():ID[] {
        // console.log("getForChildren() this.projectId=",this.projectId)

        let res: ID[] = [];

        // const allChildrenProjects : ProjectSession[] = gd.session.projects.getAllChildren(this.projectId)
        const allChildrenProjects : ProjectSession[] = gd.session.projects.getAllChildrenOptimized(this.projectId)

        // get all children custom fields
        _.map(allChildrenProjects, (project:ProjectSession)=>{

            res = res.concat(this.getProjectTasksCustomFields(project));
        });

        return res;
    }

    getAll() {
        const {ownCustomFieldsIds, inheritedCustomFieldsIds} = this.get();
        const childrenCustomFieldsIds = this.getForChildren();
        return _.union(ownCustomFieldsIds, inheritedCustomFieldsIds, childrenCustomFieldsIds);
    }

    getCustomFields() {
        const {ownCustomFieldsIds, inheritedCustomFieldsIds} = this.get();

        // get own custom fields objects
        const ownCustomFields: any[] = _.map(ownCustomFieldsIds, id=>gd.session.customFields.get(id).clone())

        // get inherited custom fields objects marked with isInherited flag
        const inheritedCustomFields = _.map(inheritedCustomFieldsIds, id=>{
            const customField = gd.session.customFields.get(id).clone();
            customField.setInherited(true);
            return customField;
        })

        return _.union(ownCustomFields, inheritedCustomFields)
    }

    getProjectTasksCustomFields(project: ProjectSession):ID[] {
        let res: ID[] = [];

        // we do it because CF may not present in session or be deleted
        _.map(project.customFields, (id:ID)=>{
            const customField = gd.session.customFields.get(id);
            if (customField && !customField.isDeleted) res.push(id)
        });

        return res;
    }
}